module.exports = __webpack_public_path__ + "media/patterns/stars-2-2ce76cfc.svg";